// extracted by mini-css-extract-plugin
export default {"item":"CheckableFormItem_item__fiLd-","checkbox":"CheckableFormItem_checkbox__B5r-8"};